import { useTranslation } from 'react-i18next';

import { Panel } from 'components/containers';
import { CustodialWalletTransactionStatusBadge } from 'components/pwcRefundTransactionBadge';

import { CurrencyCode } from 'types/currency';
import { CustodialWalletTransaction } from 'types/custodialWallet';

import { formatFiatCurrencyI18n } from 'utils/i18n';

import { LABELS } from './keys';
import { Delimiter, Item, ItemName, ItemValue, TopAreaContainer } from './styles';

interface TopAreaSectionProps {
  transaction: CustodialWalletTransaction;
  currencyCode: CurrencyCode;
}

export const TopAreaSection = ({ transaction, currencyCode }: TopAreaSectionProps) => {
  const { t, i18n } = useTranslation();

  return (
    <Panel>
      <TopAreaContainer>
        <Item>
          <ItemName>{t(LABELS.TOPUP_ID)}:</ItemName>
          <ItemValue unique>{transaction.uuid}</ItemValue>
        </Item>

        <Delimiter />

        <Item>
          <ItemName>{t(LABELS.AMOUNT)}:</ItemName>
          <ItemValue>{formatFiatCurrencyI18n(i18n.language)(Number(transaction.amount), currencyCode)}</ItemValue>
        </Item>

        <Delimiter />

        <Item>
          <ItemName>{t(LABELS.STATUS)}: </ItemName>
          <ItemValue>
            <CustodialWalletTransactionStatusBadge status={transaction.status} />
          </ItemValue>
        </Item>
      </TopAreaContainer>
    </Panel>
  );
};
